import axios from "axios";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { QRCodeCanvas } from 'qrcode.react';

const apiUrlDirecciones = process.env.REACT_APP_API_DIRECCIONES;

function AbmDirecciones() {
    const [direciones, setDirecciones] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [showModal, setShowModal] = useState(false)
    const [sedeAEliminar, setSedeAEliminar] = useState(null)
    const [showQRModal, setShowQRModal] = useState(false)
    const [sedeParaQR, setSedeParaQR] = useState(null)
    const navigate = useNavigate();

    useEffect(() => {
        getaddres()
    }, [])

    const getaddres = async () => {
        try {
            setIsLoading(true)
            const res = await axios.get(apiUrlDirecciones)
            setDirecciones(res.data)
        } catch (error) {
            console.error("Error al intentar mostrar sedes;", error)
            alert('❌ Error al cargar las sedes')
        } finally {
            setIsLoading(false)
        }
    };

    const confirmarEliminacion = (sede) => {
        setSedeAEliminar(sede)
        setShowModal(true)
    }

    const deleteAddres = async () => {
        try {
            await axios.delete(`${apiUrlDirecciones}${sedeAEliminar.id_direccion}`);
            alert('✅ Sede eliminada correctamente')
            setShowModal(false)
            setSedeAEliminar(null)
            getaddres();
        } catch (error) {
            console.error("Error al intentar eliminar sede;", error);
            alert('❌ Error al eliminar la sede: ' + (error.response?.data?.error || error.message));
        }
    };

    const descargarQR = () => {
        const canvas = document.getElementById("qr-gen");
        const pngUrl = canvas
            .toDataURL("image/png")
            .replace("image/png", "image/octet-stream");
        let downloadLink = document.createElement("a");
        downloadLink.href = pngUrl;
        downloadLink.download = `QR_Menu_${sedeParaQR?.nombre_sede}.png`;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    };

    if (isLoading) {
        return (
            <div className="min-h-screen bg-gradient-to-br from-blue-50 via-cyan-50 to-teal-100 flex items-center justify-center">
                <div className="bg-white p-8 rounded-2xl shadow-xl">
                    <div className="flex items-center gap-4">
                        <svg className="animate-spin h-8 w-8 text-blue-600" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                        </svg>
                        <span className="text-lg font-semibold text-gray-700">Cargando sedes...</span>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 via-cyan-50 to-teal-100 py-8 px-4">
            <div className="max-w-7xl mx-auto">
                {/* Header */}
                <div className="bg-white rounded-2xl shadow-xl p-6 mb-6 border-b-4 border-blue-500">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-4">
                            <div className="bg-gradient-to-br from-blue-500 to-cyan-600 p-4 rounded-xl shadow-lg">
                                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                </svg>
                            </div>
                            <div>
                                <h1 className="text-3xl font-bold text-gray-800">Gestión de Sedes</h1>
                                <p className="text-gray-600 mt-1">Administra las sedes y ubicaciones del sistema</p>
                            </div>
                        </div>
                        <button
                            onClick={() => navigate('/admin/CreateAddres')}
                            className="bg-gradient-to-r from-blue-600 to-cyan-600 text-white font-bold py-3 px-6 rounded-lg shadow-lg hover:from-blue-700 hover:to-cyan-700 transform hover:scale-105 transition-all flex items-center gap-2"
                        >
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                            </svg>
                            Nueva Sede
                        </button>
                    </div>
                </div>

                {/* Tabla */}
                <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
                    <div className="overflow-x-auto">
                        <table className="w-full">
                            <thead className="bg-gradient-to-r from-blue-600 to-cyan-600 text-white">
                                <tr>
                                    <th className="px-6 py-4 text-left text-sm font-bold uppercase tracking-wider">Nombre de Sede</th>
                                    <th className="px-6 py-4 text-left text-sm font-bold uppercase tracking-wider">Dirección</th>
                                    <th className="px-6 py-4 text-left text-sm font-bold uppercase tracking-wider">Localidad</th>
                                    <th className="px-6 py-4 text-center text-sm font-bold uppercase tracking-wider">Menú QR</th>
                                    <th className="px-6 py-4 text-center text-sm font-bold uppercase tracking-wider">Acciones</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-200">
                                {direciones.length === 0 ? (
                                    <tr>
                                        <td colSpan="5" className="px-6 py-12 text-center text-gray-500">
                                            <div className="flex flex-col items-center gap-3">
                                                <svg className="w-16 h-16 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                                </svg>
                                                <p className="text-lg font-semibold">No hay sedes registradas</p>
                                                <p className="text-sm">Crea una nueva sede para comenzar</p>
                                            </div>
                                        </td>
                                    </tr>
                                ) : (
                                    direciones.map((direcciones) => (
                                        <tr key={direcciones.id_direccion} className="hover:bg-blue-50 transition-colors">
                                            <td className="px-6 py-4">
                                                <span className="font-bold text-gray-800">{direcciones.nombre_sede || 'Sin nombre'}</span>
                                            </td>
                                            <td className="px-6 py-4 text-gray-600">{direcciones.direccion}</td>
                                            <td className="px-6 py-4 text-gray-600">{direcciones.localidad}</td>
                                            <td className="px-6 py-4 text-center">
                                                <button
                                                    onClick={() => { setSedeParaQR(direcciones); setShowQRModal(true); }}
                                                    className="bg-gradient-to-r from-indigo-500 to-purple-600 text-white px-4 py-2 rounded-lg hover:from-indigo-600 hover:to-purple-700 transition-all transform hover:scale-110 shadow-md inline-flex items-center gap-2 font-semibold"
                                                    title="Ver QR del Menú"
                                                >
                                                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                                                        <path fillRule="evenodd" d="M3 4a1 1 0 011-1h3a1 1 0 011 1v3a1 1 0 01-1 1H4a1 1 0 01-1-1V4zm2 2V5h1v1H5zM3 13a1 1 0 011-1h3a1 1 0 011 1v3a1 1 0 01-1 1H4a1 1 0 01-1-1v-3zm2 2v-1h1v1H5zM13 3a1 1 0 00-1 1v3a1 1 0 001 1h3a1 1 0 001-1V4a1 1 0 00-1-1h-3zm1 2v1h1V5h-1z" clipRule="evenodd" />
                                                        <path d="M11 4a1 1 0 10-2 0v1a1 1 0 002 0V4zM10 7a1 1 0 011 1v1h2a1 1 0 110 2h-3a1 1 0 01-1-1V8a1 1 0 011-1zM16 9a1 1 0 100 2 1 1 0 000-2zM9 13a1 1 0 011-1h1a1 1 0 110 2v2a1 1 0 11-2 0v-3zM7 11a1 1 0 100-2H4a1 1 0 100 2h3zM17 13a1 1 0 01-1 1h-2a1 1 0 110-2h2a1 1 0 011 1zM16 17a1 1 0 100-2h-3a1 1 0 100 2h3z" />
                                                    </svg>
                                                    QR
                                                </button>
                                            </td>
                                            <td className="px-6 py-4">
                                                <div className="flex items-center justify-center gap-2">
                                                    <button
                                                        onClick={() => navigate(`/admin/EditAddres/${direcciones.id_direccion}`)}
                                                        className="bg-gradient-to-r from-blue-500 to-cyan-600 text-white p-2 rounded-lg hover:from-blue-600 hover:to-cyan-700 transition-all transform hover:scale-110 shadow-md"
                                                        title="Editar"
                                                    >
                                                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                                        </svg>
                                                    </button>
                                                    <button
                                                        onClick={() => confirmarEliminacion(direcciones)}
                                                        className="bg-gradient-to-r from-red-500 to-rose-600 text-white p-2 rounded-lg hover:from-red-600 hover:to-rose-700 transition-all transform hover:scale-110 shadow-md"
                                                        title="Eliminar"
                                                    >
                                                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                        </svg>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Info card */}
                <div className="mt-6 bg-blue-50 border-l-4 border-blue-500 p-4 rounded-r-lg shadow-md">
                    <div className="flex items-start gap-3">
                        <svg className="w-6 h-6 text-blue-600 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                        </svg>
                        <div>
                            <p className="text-sm font-semibold text-blue-900">Códigos QR para Menús</p>
                            <p className="text-sm text-blue-700 mt-1">
                                Cada sede tiene un código QR único que permite a los usuarios ver el menú de la semana desde sus dispositivos móviles.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal de QR */}
            {showQRModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8 transform transition-all">
                        <div className="text-center mb-6">
                            <div className="bg-gradient-to-r from-indigo-500 to-purple-600 p-3 rounded-full inline-block mb-4">
                                <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M3 4a1 1 0 011-1h3a1 1 0 011 1v3a1 1 0 01-1 1H4a1 1 0 01-1-1V4zm2 2V5h1v1H5zM3 13a1 1 0 011-1h3a1 1 0 011 1v3a1 1 0 01-1 1H4a1 1 0 01-1-1v-3zm2 2v-1h1v1H5zM13 3a1 1 0 00-1 1v3a1 1 0 001 1h3a1 1 0 001-1V4a1 1 0 00-1-1h-3zm1 2v1h1V5h-1z" clipRule="evenodd" />
                                </svg>
                            </div>
                            <h3 className="text-2xl font-bold text-gray-800">Menú QR</h3>
                            <p className="text-lg font-semibold text-indigo-600 mt-1">{sedeParaQR?.nombre_sede}</p>
                            <p className="text-sm text-gray-600 mt-2">
                                Escanea este código para ver el menú de la semana
                            </p>
                        </div>

                        <div className="bg-gray-50 p-6 rounded-xl border-2 border-gray-200 mb-4 inline-block mx-auto w-full text-center">
                            <QRCodeCanvas
                                id="qr-gen"
                                value={`${window.location.origin}/ver-menu/${sedeParaQR?.id_direccion}`}
                                size={220}
                                level={"H"}
                                marginSize={4}
                            />
                        </div>

                        <div className="bg-blue-50 border-l-4 border-blue-500 p-3 rounded-r-lg mb-6">
                            <p className="text-xs text-gray-700 font-mono break-all mb-2">
                                {window.location.origin}/ver-menu/{sedeParaQR?.id_direccion}
                            </p>
                            {(window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') ? (
                                <p className="text-xs text-red-600 font-semibold">
                                    ⚠️ Usando "localhost". Los celulares no podrán leerlo. Usa tu IP de red.
                                </p>
                            ) : (
                                <p className="text-xs text-green-600 font-semibold">
                                    ✅ URL lista para compartir en red local
                                </p>
                            )}
                        </div>

                        <div className="flex gap-3">
                            <button
                                onClick={() => { setShowQRModal(false); setSedeParaQR(null); }}
                                className="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-700 font-bold py-3 px-6 rounded-lg transition-all transform hover:scale-105"
                            >
                                Cerrar
                            </button>
                            <button
                                onClick={descargarQR}
                                className="flex-1 bg-gradient-to-r from-green-600 to-emerald-600 text-white font-bold py-3 px-6 rounded-lg hover:from-green-700 hover:to-emerald-700 transition-all transform hover:scale-105 flex items-center justify-center gap-2"
                            >
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                                </svg>
                                Descargar
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal de confirmación */}
            {showModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 transform transition-all">
                        <div className="flex items-center gap-4 mb-4">
                            <div className="bg-red-100 p-3 rounded-full">
                                <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                                </svg>
                            </div>
                            <div>
                                <h3 className="text-xl font-bold text-gray-800">Confirmar Eliminación</h3>
                                <p className="text-sm text-gray-600">Esta acción no se puede deshacer</p>
                            </div>
                        </div>
                        <p className="text-gray-700 mb-4">
                            ¿Estás seguro que deseas eliminar la sede <span className="font-bold text-blue-600">"{sedeAEliminar?.nombre_sede}"</span>?
                        </p>
                        <div className="bg-yellow-50 border-l-4 border-yellow-500 p-3 rounded-r-lg mb-6">
                            <p className="text-sm text-yellow-800 font-semibold">
                                ⚠️ Esta acción no se puede deshacer
                            </p>
                        </div>
                        <div className="flex gap-3">
                            <button
                                onClick={deleteAddres}
                                className="flex-1 bg-gradient-to-r from-red-600 to-rose-600 text-white font-bold py-3 px-6 rounded-lg hover:from-red-700 hover:to-rose-700 transition-all transform hover:scale-105"
                            >
                                Eliminar
                            </button>
                            <button
                                onClick={() => { setShowModal(false); setSedeAEliminar(null); }}
                                className="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-700 font-bold py-3 px-6 rounded-lg transition-all transform hover:scale-105"
                            >
                                Cancelar
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default AbmDirecciones;
